/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_Caught_UpInputs */

const en_all_caught_up = /** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All caught up!`)
};

const id_all_caught_up = /** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua sudah Anda ketahui!`)
};

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const es_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const fr_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const de_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const ja_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const zh_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const ar_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const it_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const ru_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const pt_all_caught_up = en_all_caught_up;

/** @type {(inputs: All_Caught_UpInputs) => LocalizedString} */
const ko_all_caught_up = en_all_caught_up;

/**
* | output |
* | --- |
* | "All caught up!" |
*
* @param {All_Caught_UpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const all_caught_up = /** @type {((inputs?: All_Caught_UpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_Caught_UpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_all_caught_up(inputs)
	if (locale === "es") return es_all_caught_up(inputs)
	if (locale === "fr") return fr_all_caught_up(inputs)
	if (locale === "de") return de_all_caught_up(inputs)
	if (locale === "ja") return ja_all_caught_up(inputs)
	if (locale === "zh") return zh_all_caught_up(inputs)
	if (locale === "ar") return ar_all_caught_up(inputs)
	if (locale === "id") return id_all_caught_up(inputs)
	if (locale === "it") return it_all_caught_up(inputs)
	if (locale === "ru") return ru_all_caught_up(inputs)
	if (locale === "pt") return pt_all_caught_up(inputs)
	return ko_all_caught_up(inputs)
});